module.exports = __webpack_public_path__ + "img/access.7330c89d.jpg";